module.exports = __webpack_public_path__ + "static/media/icon_bike.9651fff9.svg";